import React from 'react';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import LazyContext from '@wix/da-shared-react/pkg/LazyLoadingImage/LazyContext';

import withSectionFetchSpinner from '../../../decorators/withSectionFetchSpinner';
import { ModuleType } from '../../../../types/modules';
import Zone, { ZoneGroup } from '../../Layout/Zone';
import { ZoneType } from '../../../../types/layout';

import { AboutMeBox } from '../../UserWidgets/AboutMe';
import { WatchersBox, WatchingBox } from '../../UserWidgets/WatchedDeviants';
import DonationsBox from '../../UserWidgets/Donations';
import FeaturedDeviation from '../../UserWidgets/FeaturedDeviation';
import FeaturedPost from '../../UserWidgets/FeaturedPost';
import StripExhibitionist from '../../UserWidgets/StripExhibitionist';
import TallExhibitionist from '../../UserWidgets/TallExhibitionist';
import { GroupsAdminBox, GroupsMemberBox } from '../../UserWidgets/Groups';
import ProfileCommentsBox from '../../UserWidgets/ProfileComments';
import DeviousnessBox from '../../UserWidgets/Deviousness';
import CustomBox from '../../UserWidgets/Custom';
import FeedBox from '../../UserWidgets/Feed';
import AdBox from '../../UserWidgets/Ad';
import TiersBox from '../../UserWidgets/Tiers';
import ActiveMembersBox from '../../UserWidgets/ActiveMembers';
import AdminsBox from '../../UserWidgets/Admins';
import WixPortfolioCallToAction from '../../UserWidgets/WixPortfolioCallToAction';

const mapModuleTypeToWidgetComponent = {
  [ModuleType.ABOUT]: AboutMeBox,
  [ModuleType.EXHIBITIONIST]: TallExhibitionist,
  [ModuleType.FEATURED_DEVIATION]: FeaturedDeviation,
  [ModuleType.FEATURED_POST]: FeaturedPost,
  [ModuleType.WATCHERS]: WatchersBox,
  [ModuleType.WATCHING]: WatchingBox,
  [ModuleType.GROUPS_ADMIN]: GroupsAdminBox,
  [ModuleType.GROUPS_MEMBER]: GroupsMemberBox,
  [ModuleType.COMMENTS]: ProfileCommentsBox,
  [ModuleType.DONATIONS]: DonationsBox,
  [ModuleType.DEVIOUSNESS]: DeviousnessBox,
  [ModuleType.FEED]: FeedBox,
  [ModuleType.CUSTOM]: CustomBox,
  [ModuleType.ACTIVE_MEMBERS]: ActiveMembersBox,
  [ModuleType.ADMINS]: AdminsBox,
  [ModuleType.TIERS]: TiersBox,
};

import s from './HomeSection.scss';

export interface Props {
  isMobile?: boolean;
}

class HomeSection extends React.Component<Props> {
  render() {
    const isMobile = this.props.isMobile;
    const zoneProps = {
      mapModuleTypeToWidgetComponent,
    };
    return (
      <div className={s['root']}>
        <LazyContext.Provider value={true}>
          {isMobile
            ? this.renderOneColumn(zoneProps)
            : this.renderTwoColumns(zoneProps)}
        </LazyContext.Provider>
      </div>
    );
  }

  renderTwoColumns(zoneProps) {
    return (
      <>
        <div className={s['zone-top']}>
          <ZoneGroup>
            <Zone
              type={ZoneType.TOP_BAR}
              mapModuleTypeToWidgetComponent={{
                [ModuleType.EXHIBITIONIST]: StripExhibitionist,
                [ModuleType.TIERS]: TiersBox,
              }}
            />
          </ZoneGroup>
        </div>
        <div className={s['flex-wrap']}>
          <div className={s['zone-column-left']}>
            <ZoneGroup disableTopAddWidget={true}>
              <Zone type={ZoneType.TOP_LEFT} {...zoneProps} />
              <Zone type={ZoneType.BOTTOM_LEFT} {...zoneProps} />
            </ZoneGroup>
          </div>
          <div className={s['zone-column-right']}>
            <WixPortfolioCallToAction />
            <ZoneGroup>
              <Zone type={ZoneType.TOP_RIGHT} {...zoneProps} locked={true} />
            </ZoneGroup>
            <AdBox />
            <ZoneGroup>
              <Zone type={ZoneType.MID_RIGHT} {...zoneProps} />
              <Zone type={ZoneType.BOTTOM_RIGHT} {...zoneProps} />
            </ZoneGroup>
          </div>
        </div>
      </>
    );
  }

  renderOneColumn(zoneProps) {
    return (
      <div className={s['flex-wrap']}>
        <div className={s['zone-top']}>
          <ZoneGroup>
            <WixPortfolioCallToAction />
            <Zone type={ZoneType.TOP_RIGHT} {...zoneProps} locked={true} />
          </ZoneGroup>
        </div>
        <ZoneGroup>
          <Zone type={ZoneType.TOP_BAR} {...zoneProps} />
          <Zone type={ZoneType.TOP_LEFT} {...zoneProps} />
          <Zone type={ZoneType.MID_RIGHT} {...zoneProps} />
          <Zone type={ZoneType.BOTTOM_LEFT} {...zoneProps} />
          <Zone type={ZoneType.BOTTOM_RIGHT} {...zoneProps} />
        </ZoneGroup>
      </div>
    );
  }
}

export default withMobileContext(withSectionFetchSpinner(HomeSection));
